import request from '@/utils/request'

export const getTraceTemplateItemsList = (productTemplateId) => {
  return request({
    url: `/trace/template/items/tid/${productTemplateId}`
  })
}

export const postTraceTemplateItemsEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/template/items',
    data
  })
}

export const putTraceTemplateItemsAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/template/items',
    data
  })
}

export const getTraceTemplateItemsDetail = (id) => {
  return request({
    url: `/trace/template/items/${id}`
  })
}

export const deleteTraceTemplateItemsDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/template/items/${id}`
  })
}

export const delTraceTemplateItemsList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/template/items/all',
    data
  })
}

export const postTraceTemplateItemsDown = ({ productTemplateID, id }) => {
  return request({
    method: 'post',
    url: `/trace/template/items/down/${productTemplateID}/${id}`
  })
}

export const postTraceTemplateItemsUp = ({ productTemplateID, id }) => {
  return request({
    method: 'post',
    url: `/trace/template/items/up/${productTemplateID}/${id}`
  })
}
